import styled from '@emotion/styled'

interface ResultsStyleProps {
    isFullSize: boolean
}

export const StyledResultsWrap = styled('div')<ResultsStyleProps>(
    ({ theme, isFullSize }) => ({
        height: '100%',
        background: 'white',
    }),
)
